import { __rest } from 'tslib';
import React__default from 'react';
import { Body, Caption } from './components/Typography.es.js';
import { DeleteCircleFilled, hasColoredIcon } from '@teko/ds-icon';
import { CommonStyles } from './components/BaseProps.es.js';
import { styled } from '@teko/styled';

const MAPPING_HEIGHT = {
    m: 24,
    l: 32,
};
const Wrapper = styled.span `
  ${CommonStyles}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s12};
  padding-right: ${(p) => p.theme.spacing.s12};
  background-color: ${(p) => p.theme.colors.white};
  height: ${(p) => MAPPING_HEIGHT[p.size]}px;
  border-radius: 1.5rem;
  border: ${(p) => p.theme.borderWeight.m} solid
    ${(p) => p.theme.colors.disable};
  ${(p) => p.disabled
    ? 'cursor: not-allowed;'
    : `
  `}
`;
const Chip = (_a) => {
    var { content, size = 'm', closable, closeIcon, disabled = false, onClose = () => { }, onClick } = _a, props = __rest(_a, ["content", "size", "closable", "closeIcon", "disabled", "onClose", "onClick"]);
    const getColorCloseIcon = () => {
        var _a;
        if (!closable || closeIcon || hasColoredIcon(closeIcon))
            return undefined;
        if (disabled)
            return 'disabled';
        if (!((_a = closeIcon === null || closeIcon === void 0 ? void 0 : closeIcon.props) === null || _a === void 0 ? void 0 : _a.color))
            return 'placeholder';
        return closeIcon.props.color;
    };
    const renderClose = () => {
        var _a, _b;
        if (!closable)
            return null;
        return closeIcon ? (React__default.cloneElement(closeIcon, {
            size: !((_a = closeIcon === null || closeIcon === void 0 ? void 0 : closeIcon.props) === null || _a === void 0 ? void 0 : _a.size) ? 16 : closeIcon.props.size,
            color: getColorCloseIcon(),
            onClick: (e) => !disabled && onClose(e),
            style: Object.assign(Object.assign({}, (_b = closeIcon === null || closeIcon === void 0 ? void 0 : closeIcon.props) === null || _b === void 0 ? void 0 : _b.style), { cursor: disabled ? 'not-allowed' : 'pointer' }),
        })) : (React__default.createElement(DeleteCircleFilled, { color: disabled ? 'disable' : 'placeholder', size: 16, style: { cursor: disabled ? 'not-allowed' : 'pointer' }, onClick: (e) => !disabled && onClose(e) }));
    };
    return (React__default.createElement(Wrapper, Object.assign({ onClick: () => {
            !disabled && onClick && onClick();
        }, size: size, disabled: disabled }, props), size === 'l' ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Body, { level: 1, weight: "regular", line: 1, color: disabled ? 'disable' : 'textPrimary', marginRight: closable ? 's8' : undefined }, content),
        renderClose())) : (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Caption, { level: 1, weight: "regular", line: 1, color: disabled ? 'disable' : 'textPrimary', marginRight: closable ? 's4' : undefined }, content),
        renderClose()))));
};

export { Chip as C };
